import React from "react";
import { PropTypes } from "prop-types";
import { HomePageLayout } from "application/home/components";
import { Category, CategoryPageHeader } from "application/categories/components";
import { MrbPageHeader } from "mrb/components/layout";
import { defaultTemplate } from "common/hoc";

function ShiurimPageTemplate({ shiurimViewStore, t }) {
    return (
        <HomePageLayout store={shiurimViewStore} t={t}>
            <div>
                <MrbPageHeader classNameExtend="c-page__header--secondary">
                    <CategoryPageHeader store={shiurimViewStore} t={t} />
                </MrbPageHeader>
                <Category store={shiurimViewStore} t={t} />
            </div>
        </HomePageLayout>
    );
}

ShiurimPageTemplate.propTypes = {
    shiurimViewStore: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default defaultTemplate(ShiurimPageTemplate);
